module.exports = __webpack_public_path__ + "static/media/ee.10ca31ea.svg";